<template>
    <LoadingCard v-if="loading && !hasLoaded" />
    <div v-else>
        <header class="content__title pl-0">
            <h1>Users</h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new User"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">All Users</h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>

            <b-table small hover stacked="md" :items="tableData" :fields="table.fields"
                     :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                     :no-local-sorting="true"
                     :busy="this.loading > 0"
                     :per-page="pagination.limit" :current-page="pagination.page"
                     :show-empty="true">
                <template slot="roles" slot-scope="data">
                    {{ data.item.role.title}}
                </template>
                <template slot="is_processor_managed" slot-scope="data">
                    <template v-if="data.item.is_processor_managed">
                        <span v-if="data.item.processors.length === 0" class="badge badge-danger">Managed Without Processor</span>
                        <span class="badge badge-alt-green" v-else v-for="{processor} in data.item.processors">
                            {{ processor.name }}
                        </span>
                    </template>
                    <template v-else>
                        <span class="badge badge-light">Independent</span>
                    </template>

                </template>
                <template slot="created_at" slot-scope="row">
                    <span class="text-nowrap">{{ row.item.created_at | date_format }}</span>
                </template>
                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>
                <template slot="actions" slot-scope="row">
                    <b-btn class="btn--icon btn-purple"
                           @click.prevent="$root.startGhosting(row.item.id)"
                           v-b-tooltip="'Login as user'">
                        <i class="zmdi zmdi-accounts"></i>
                    </b-btn>
                    <b-button
                            @click="showEditDialog(row.item)"
                            variant="secondary btn--icon" size="sm"
                            v-b-tooltip.hover="'Edit User'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" :user="editingUser" v-model="editingUser" v-if="editingUser" />
    </div>
</template>
<script>
import listUsersQuery from '@views/Users/queryListUsers.graphql';
import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseUsers',
  props: { 'role': String },
  apollo: {
    users: {
      query: listUsersQuery,
      update: data => data.filterUsers.data,
      variables() {
        const variables = {
          input: {
            include_deleted: true,
            sort: {
              direction: this.sortDesc ? 'DESC' : 'ASC',
              field: this.sortBy,
            },
          },
        };

        if (this.role) {
          variables.input.role = this.role;
        }

        return variables;
      },
      result({ data, loading }) {
        if (!loading) {
          this.users = data.filterUsers.data;
          this.pagination.total = data.filterUsers.meta.total;
        }
      },
    },
  },
  data() {
    return {
      users: [],
      hasLoaded: false,
      loading: 0,
      editingUser: null,
      creating: false,
      sortBy: 'name',
      sortDesc: false,
      pagination: {
        page: 1,
        limit: this.$tableDefaultPageSize,
        total: 0,
      },
    };
  },
  computed: {
    tableData() {
      return this.users;
    },
    table() {
      return {
        fields: [
          { key: 'name', label: 'Name', sortable: true },
          { key: 'business_name', label: 'Business', sortable: true },
          { key: 'email', label: 'Email' },
          { key: 'created_at', label: 'Signup Date', sortable: true  },
          this.role ? null : { key: 'roles', label: 'Roles' },
          this.role === 'grower' ? { key: 'is_processor_managed', label: 'Managed', sortable: true } : null,
          { key: 'badges', label: 'Statuses' },
          { key: 'actions', label: ' ', tdClass: 'text-right' },
        ].filter(Boolean),
      };
    },
  },
  watch: {
    loading(newValue) {
      if (!this.hasLoaded && newValue === 0) {
        this.hasLoaded = true;
      }
    },
  },
  methods: {
    showEditDialog(user) {
      this.editingUser = user;
    },
    closeEditDialog() {
      this.editingUser = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
